export default {
  Reports: {
    Titles: {
      NewUsersPayments: 'گزارش کاربران جدید',
      UsersAndPayments: 'گزارش کاربران و پرداختی‌ها در روز ثبت‌نام',
      PaymentsPercent: 'گزارش پرداختی‌ها',
      PaymentRateChart: 'نمودار رشد پرداخت ها',
    },
    Series: {
      NewUsersPayments: {
        Payments: {
          Success: 'پرداخت موفق',
          UnSuccess: 'پرداخت ناموفق',
          Without: 'بدون پرداخت',
        },
        All: 'همه',
      },
      UsersAndPayments: {
        Payments: {
          Success: 'پرداخت‌های موفق',
          UnSuccess: 'پرداخت‌های ناموفق',
          Without: 'کاربران بدون پرداخت',
        },
        All: 'تعداد کاربران',
      },
      PaymentsPercent: {
        Success: 'پرداخت موفق',
        UnSuccess: 'پرداخت ناموفق',
      },
      IncreaseRate: 'درصد رشد',
      PastCount: 'نرخ درگذشته',
      PastAvg: 'میانگین گذشته',
      CompareWith: 'مقایسه با',
      MAgo: 'یک ماه گذشته',
      TwoMAgo: 'دو ماه گذشته',
      ThreeMAgo: 'سه ماه گذشته',
      SixMAgo: 'شش ماه گذشته',
    },
    Sign: {
      Device: ' شماره دستگاه ',
      Service: 'سرویس',
      DollarCost: 'هزینه به دلار',
      TotalCost: ' مقدار کلی به دلار',
      TotalCount: 'تعداد کلی',
    },
    ForNewUsers: 'پرداخت کاربران جدید',
  },
}
